// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "table.grid th[data-v-362ae4a5] {\n  color: var(--color-text-light);\n  height: 44px;\n}\ntable.grid .group-header th[data-v-362ae4a5] {\n  padding-top: 16px;\n  height: 60px;\n}\ntable.grid td[data-v-362ae4a5] {\n  padding-left: 0;\n}\ntable.grid th.activity_select_group[data-v-362ae4a5] {\n  color: var(--color-main-text);\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
